export default __webpack_public_path__ + "static/banner-03-164b1af1259c28a89f4cfb898ce52768.png";